module.exports = __webpack_public_path__ + "static/media/ico-headset.05cbc704.svg";